export const PATH_NAME = {
    EXACT: '/',
    YOUR_ORDER: '/your-order',
    CONTACT_INFO: '/contact-info',
    ORDER_SUMMARY: '/order-summary',
    DEMO: '/demo',
    USER_PROFILE: '/user-profile',
    LOGIN: '/login',
    REGISTER: '/register',
    FORGOTTEN_PASSWORD: '/forgotten-password',
    CHANGE_FORGOTTEN_PASSWORD: '/change-forgotten-password',
    THANKS_FOR_ORDER: '/thanks-for-order',
    TICKETS_RESERVED: '/tickets-reserved',
    PAYMENT_FAILED: '/payment-failed',
    EXPIRED_LIMIT: '/expired-limit',
    ERROR: '/error',
    NOT_FOUND: '/not-found',
    VERIFY_PAYMENT: '/verify-payment',
    EVERYTHING_ELSE: '*',
    HEALTHCHECK: '/healthcheck',
    BUY_TICKET_VOUCHER: '/buy-ticket-voucher',
    GDPR: '/gdpr',
    Maintenance: '/maintenance',
}

export const EXTERNAL_LINKS = {
    VSEOBECNE_PODMINKY: 'https://www.cinestar.cz/cz/vseobecne-obchodni-podminky/',
}
